import { CartLinesUpdateEvent } from '@shopify/events';

class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('.cart-upsell__btn');
    this.btn?.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.btn?.removeEventListener('click', this.onClick);
  }

  onClick = async () => {
    if (this.busy) return;
    this.busy = true;
    this.classList.add('is-busy');
    const variantId = String(this.dataset.variantId);
    const sections = [
      ...new Set(
        [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean)
      ),
    ].join(',');
    try {
      const res = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      }).then((r) => r.json());
      if (res && res.status) throw new Error(res.description || res.message || 'Cart error');
      const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
        r.json()
      );
      const line = cart.items.find((i) => String(i.variant_id) === variantId);
      this.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'update',
          context: 'cart',
          lines: [{ id: line?.key || variantId, quantity: line?.quantity || 1 }],
          promise: Promise.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              itemCount: cart.item_count,
              source: 'cart-upsell',
              sections: res?.sections,
              didError: false,
            },
          }),
        })
      );
    } catch (err) {
      console.error('[cart-upsell]', err);
      this.busy = false;
      this.classList.remove('is-busy');
    }
  };
}

if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', CartUpsell);
}